// @ts-ignore
import CircleIcon from '../../assets/icons/circle.svg?react';
// @ts-ignore
import CheckIcon from '../../assets/icons/check.svg?react';

type ToggleProps = {
  isChecked: boolean;
  onToggle: () => void;
};

const Toggle = ({ isChecked, onToggle }: ToggleProps) => {
  return (
    <span style={{ cursor: 'pointer' }} onClick={onToggle}>
      {isChecked ? <CheckIcon /> : <CircleIcon />}
    </span>
  );
};

export default Toggle;
